import axios from "axios";
import { createContext, useEffect, useState } from "react";

export const ApiLinkContext = createContext();

export const ApiLinkProvider = (props) => {
  const [data,setData] = useState([])
  const [cat,setCat] = useState([])
  const [selectedData,setSelectedData] = useState(null)

  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);


  useEffect(() => {
      Promise.all([
        axios.get('https://new.myshops.az/api2/app_prod.php'),
        axios.get('https://myshops.az/apk/app_cat.php')
      ])
      .then(([productRes,catRes])=>{
         // Sadəcə Vertu məhsullarını filterləyirik
         const vertuProducts = productRes.data.filter(item => {
           const matchNameAz = item.name_az && item.name_az.toLowerCase().includes('vertu');
           const matchNameShow = item.name_show && item.name_show.toLowerCase().includes('vertu');
           const hasIcon = item.icon && item.icon.trim() !== "";
           return (matchNameAz || matchNameShow) && hasIcon;
         });
         
         setData(vertuProducts)
         setCat(catRes.data)
         setLoading(false)
      })
      .catch((err)=>{
        setLoading(err)
      })
  }, []);

  return (
    <ApiLinkContext.Provider
      value={{ data,cat ,loading, err }}
    >
      {props.children}
    </ApiLinkContext.Provider>
  );
};

export default ApiLinkContext;